<template>
  <div class="wrapper">

    <div class="container">
      <div v-show="tabA">
        <div class="cont-head" :class="{'newStyle':!newStyle,'DE1':isDe||isPo||isIt||isSw||isCz}">
          <span>{{$t('applyHcp')}}</span>
        </div>
        <div class="pic">
         <img src="../assets/doctor.png">
        </div>
        <div class="icon-bor">
          <select id="chooseCountry" @change="select">
            <option value="GB">United Kingdom (mmol/L)</option>
            <option value="AU">Australia (mmol/L)</option>
            <option value="CN">中国 (mmol/L)</option>
            <option value="HKF">香港(中国) (mmol/L)</option>

            <option value="TH">Thailand (mg/dL)</option>
            <option value="ID">Indonesia (mg/dL)</option>
            <option value="MY">Malaysia (mmol/L)</option>
            <option value="IN">India (mg/dL)</option>

            <option value="FR">France (mg/dL)</option>
            <option value="DE">Deutschland (mg/dL)</option>
            <option value="DD">Deutschland (mmol/L)</option>
            <option value="HU">Magyarország (mmol/L)</option>
            <option value="IT">Italia (mg/dL)</option>
            <option value="NL">Nederland (mmol/L)</option>
            <option value="Nor">Norge (mmol/L)</option>
            <option value="PT">Portugal (mg/dL)</option>
            <option value="ES">España (mg/dL)</option>
            <option value="SE">Sverige (mmol/L)</option>
            <option value="TR">Turkey (mg/dL)</option>
            <!--<option value="AE">United Arab Emirates (mg/dL)</option>-->
            <option value="Ro">Romania (mg/dL)</option>
            <option value="CZ">Czech republika (mmol/L)</option>
            <option value="SK">Slovenska republika (mmol/L)</option>
            <option value="LT">Lithuania (mmol/L)</option>
            <option value="PL">Polska (mg/dL)</option>
            <option value="DK">Danmark (mmol/L)</option>
            <option value="FI">Suomi (mmol/L)</option>
            <option value="CH">Switzerland (mmol/L)</option>
            <option value="SA">Saudi  (mg/dL)</option>
            <option value="AE">United Arab (mmol/L)</option>
            <option value="QA">Qatar  (mmol/L)</option>
            <option value="QW">Kuwait (mmol/L)</option>
            <!-- 2020.3.16 新增 -->
            <option value="RH">Croatia (mmol/L)</option>   <!-- 克罗地亚 -->
            <option value="AT">Austria (mg/dL)</option>   <!-- 奥地利 -->
            <option value="SI">Slovenia (mmol/L)</option>   <!-- 斯洛文尼亚 -->
            <option value="EE">Estonia (mmol/L)</option>   <!-- 爱沙尼亚 -->
            <option value="LV">Latvia (mmol/L)</option>   <!-- 拉脱维亚 -->
            <option value="BA">Bosnia and Herzegovina (mmol/L)</option>   <!-- 波黑  -->
            <option value="BG">Bulgaria (mmol/L)</option>   <!-- 保加利亚 -->
            <option value="CL">Chile (mmol/L)</option>   <!-- 智利 -->
            <option value="BE">Belgium (mg/L)</option>   <!-- 比利时 -->

          </select>
        </div>

        <div class="icon-bor" :class="{ 'in':isI ,'vuerify-invalid':isR}">
          <el-tooltip :disabled= disE  placement="top" effect="light">
            <div class="tooltip"  slot="content">
              <span>{{$t('errtip5')}}</span>
            </div>
            <input type="text" :placeholder=nam  v-model="name" @focus="check57(0)" @blur="check57(1)" >
          </el-tooltip>

        </div>

        <div class="icon-bor" :class="{ 'in':isJ ,'vuerify-invalid':isS}">
          <el-tooltip :disabled= disF  placement="top" effect="light">
            <div class="tooltip"  slot="content">
              <span>{{$t('errtip7')}}</span>
            </div>
            <input type="text" :placeholder=org v-model="organization" @focus="check58(0)" @blur="check58(1)" >
          </el-tooltip>
        </div>

        <div class="icon-bor" v-show="isD" :class="{ 'in':isF,'vuerify-invalid':isO,'It2':isIt}">
          <el-tooltip  :disabled= disA  placement="top" effect="light" offset="-30">
            <div slot="content"  class="tooltip">
              <span>{{$t('errtip1-1')}}</span><br><span>{{$t('errtip1-2')}}</span>
            </div>
            <input type="text" :placeholder=ema  v-model="email" @focus="check54(0)" @blur="check54(1)" :class="{'DE2':isDe}">
          </el-tooltip>
        </div>

        <div class="icon-bor" :class="{ 'in':isK ,'vuerify-invalid':isT}">
          <el-tooltip :disabled= disB  placement="top" effect="light" >
            <div slot="content"  class="tooltip">
              <span>{{$t('errtip2')}}</span>
            </div>
            <input :placeholder=phone v-model="mobile" @focus="check59(0)" @blur="check59(1)" :class="{'DE2':isDe}">
          </el-tooltip>
        </div>


        <div  class="operate"  :class="[ isA ?'xSelect':'xnoSelect']">
          <!--<input type="checkbox"  @click="check1()">
          <label>{{$t('agree')}}<span><a href="http://www.medtrum.com/privacy_policy.html">{{$t('privacy')}}</a></span>
            {{$t('and')}}<span><a href="http://www.medtrum.com/terms_of_use.html">{{$t('use')}}</a></span></label>-->
        </div>

        <div  @click="register">
          <button class="register" :class="{'click':true,'DE2':isDe}" :disabled="!isNext">{{$t('Next')}}</button>
        </div>
      </div>

      <div v-show="tabB">
        <div class="policy-wrap">
          <div v-show="isEU">
            <p>We will only process your Healthcare data through Medtrum App/website with your consent.</p><br/>

            <!--<p>If you are under 16 years of age, you will need the consent of your parent or legal guardian to register in this App.</p><br/>-->

            <div class="check" :class="[ isA ?'Select':'noSelect']">
              <input type="checkbox"  @click="check1()">
              <span>I Agree to <a href="http://www.medtrum.co.uk/terms_of_use.html" target="_blank">the Terms of Use of Medtrum</a></span>
            </div>

            <div class="check" :class="[ isA2 ?'Select':'noSelect']">
              <input type="checkbox"  @click="check1_2()">
              <span>I Agree to <a href="http://www.medtrum.co.uk/privacy_policy.html" target="_blank">the Privacy Policy of Medtrum</a></span>
            </div>
            <br/>
          </div>

          <div v-show="!isEU">
            <p>We will only process your Healthcare data through Medtrum App/website with your consent.</p> <br/>

            <!--<p>If you are under 16 years of age, you will need the consent of your parent or legal guardian to register in this App.</p><br/>-->


            <div class="check" :class="[ isA ?'Select':'noSelect']">
              <input type="checkbox"  @click="check1()">
              <span>I Agree to <a href="http://www.medtrum.co.uk/terms_of_use.html" target="_blank">the Terms of Use of Medtrum</a></span>
            </div>

            <div class="check" :class="[ isA2 ?'Select':'noSelect']">
              <input type="checkbox"  @click="check1_2()">
              <span>I Agree to <a href="http://www.medtrum.com/privacy_policy.html" target="_blank">the Privacy Policy of Medtrum</a></span>
            </div>
            <br/><br/><br/><br/>
          </div>

          <div >
            <button class="send-apply" @click="register" :class="{'click':isAgree,'newStyle1':!newStyle}" :disabled="!isAgree">{{$t('send')}}</button>
            <span class="back-link"><a href="javascript:void(0)" @click="registerBack()">Back</a></span>
          </div>

        </div>
      </div>

      <div v-show="tabA1" class="tabA1">
        <div class="policy-wrap">
          <div>
            <p v-html="$t('hcp_apply_user_exist')">This email address has been used by a patient/caregiver account. If you want to switch to an HCP account, choose Next.
            </p><br/>

            <br/>
          </div>

          <div >
            <button class="next_step" @click="nextStepA1" >{{$t('Next')}}</button>
            <!--<span class="back-link"><a href="javascript:void(0)" @click="registerBack()">Back</a></span>-->
          </div>

          <div >
            <p class="back"><a href="javascript:void(0)" @click="prevStepA1">{{$t('Back')}}</a></p>
          </div>

        </div>
      </div>

      <!--
      <div class="verify" v-show="tabA2"  >
        <span>{{$t('Enter veri')}}</span>
        <img src="../assets/Verfication Code.png">
        <p v-show="!isZh">{{$t('VcodeTip1')}}<span class="tryAgain" @click="sendSeccode1" :class="{'disAble':tryAgain}">{{$t('VcodeTip2')}}</span>{{$t('VcodeTip3')}}
          <span class="userName">{{username}}</span></p>
        <p v-show="isZh">{{$t('VcodeTip1')}}<span class="userName">{{username}}</span>{{$t('VcodeTip2')}}
          <span class="tryAgain" @click="sendSeccode1" :class="{'disAble':tryAgain}">{{$t('VcodeTip3')}}</span>
        </p>
        <div class="icon-bor icon-spe2" :class="{'in': isE }">
          <input type="text" :placeholder=veri @focus="check4()" @blur="check4()" v-model="Vcode">
        </div>
        <button class="next" @click="check2(0)">{{$t('Next')}}</button>
        <button class="cancel" @click="check1(1)">{{$t('Back')}}</button>
      </div>-->  <!--verify结束-->

      <!--  -->
      <div v-show="tabA2" class="tabA2">
        <div class="policy-wrap">
          <div class="title">
            <p>{{$t('Enter veri')}}</p>
          </div>

          <div class="icon">
            <img src="../assets/Verfication Code.png" />
          </div>

          <div class="text">
            <p v-html="$t('check_email_for_code')" id="check_email_for_code"></p><br/>
            <p><a class="try_again" :class="{'try_enable':try_enable}" @click="tryAgainProc">{{$t('try_again')}} {{this.try_timer_text}}</a></p>
            <br/>
          </div>

          <div class="veri_code icon-spe2" :class="{'veri_focus': veri_focus }">
            <input type="text" :placeholder=veri_placeholder @focus="checkVeriCode()" @blur="checkVeriCode()" v-model="veri_code">
          </div>

          <div >
            <button class="next_step" @click="nextStepA2" >{{$t('Next')}}</button>
            <button class="cancel" @click="prevStepA2">{{$t('Back')}}</button>
          </div>

          <div v-if="false">
            <p class="back"><a href="javascript:void(0)" @click="prevStepA2">{{$t('Back')}}</a></p>
          </div>

        </div>
      </div>

      <div v-show="tabA3" class="tabA3">
        <div class="policy-wrap">
          <div class="title">
            <p>{{$t('Completed')}}</p>
          </div>

          <div class="icon">
            <img src="../assets/Verfication Code.png" />
          </div>

          <div class="text">
            <p>{{$t('application_has_been_submitted')}}</p><br/>

            <br/>
          </div>

          <div class="bottom_btn">
            <button class="next_step" @click="signInNow" >{{$t('OK')}}</button>
          </div>

        </div>
      </div>

    </div><!--container结束-->
  </div>
</template>

<script>
  import auth from '../auth/auth'
import format from '@/lib/format'
  export default {
    data() {
      return {
        try_enable:false,
        try_timer:'',
        try_timer_text:'60 sec',
        try_timer_value:60,
        veri_focus:false,
        veri_placeholder:'Enter code',
        veri_code:'',
        email:'', name:'',organization:'', mobile:'', error: '', token:'',isDe:false,isCz:false,
        disE:true, disF:true,disA:true,disB:true,applyHcp:'',isIt:false,isPo:false,isSw:false,
        isNext:true, tabA:true, tabA1:false, tabA2:false, tabA3:false, tabB:false, isAgree:false, isA2:false,isEU:false,

        country:['GB','CN','FR','DD','SE','AU','HKF','HU','IT','NL',   // 10个一行
          'Nor','PT','ES','TR','AE','Ro','CZ','SK','LT','PL',   // 便于计数
          'DK','FI','TH','ID','MY','IN','CH','SA','AE','QA',
          'QW','RH','AT','SI','EE','LV','BA','BG','CL', 'BE'          // 2020.1.2 增加， RH 到 CL ， 共8个
        ],    // 保持一致

        /*
        country:[
          "GB",
          "AU",
          "CN",
          "HKF",

          "TH",
          "ID",
          "MY",
          "IN",

          "FR",
          "DE",
          "DD",
          "HU",
          "IT",
          "NL",
          "Nor",
          "PT",
          "ES",
          "SE",
          "TR",
          "AE",
          "Ro",
          "CZ",
          "SK",
          "LT",
          "PL",
          "DK",
          "FI",
          "CH",
          "SA",
          "AE",
          "QA",
          "QW",

          "RH",
          "AT",
          "SI",
          "EE",
          "LV",
          "BA",
          "BG",
          "CL",
          "BE"],*/

        nam:'',
        org:'',
        ema:'',
        phone:'',

        canClick:false,hostname:'',

        newStyle:false,
        isA:false, isB:true, isC:false, isD:true, isE:false, isF:false,
        isG:false, isH:false, isI:false, isJ:false, isK:false,
        isO:false, isP:false,isQ:false, isR:false,isS:false, isT:false,
      }
    },
    computed: {
      errors () {
        return this.$vuerify.$errors
      },
      getLanguage(){
        return this.$store.state.language;
      }
    },
    vuerify: {
      mobile:'mobile',
      email: 'email',
    },
    watch:{
      //在computed中实时返回state中的数据，然后watch中监听
      getLanguage(val){
        this.ema = this.$t('Enter email');
        this.nam = this.$t('Name');
        this.org = this.$t('org');
        this.phone =  this.$t('Enter mobile');
        if(val==='zh'){
          this.newStyle=true;
        }else{
          this.newStyle=false;
        }
        //console.log(this.newStyle);
      }
    },
    methods: {
      //注册
      register(e) {
        let info = {
          name:this.name,
          org:this.organization,
          country:'',
          email:this.email,
          phone:this.mobile,
        };
        console.log('register:'+[this.disA, this.disB, this.disE, this.disF]);
        console.log('register:'+[this.isO, this.isR, this.isS, this.isO]);
        //if (!this.isO&&!this.isR&&!this.isS&&!this.isT) {
        if (this.name && this.organization && this.email && this.mobile) {
          if(this.disA&&this.disB&&this.disE&&this.disF){
            let obj = document.getElementById('chooseCountry');
            info.country = obj.value;
            info.test='yes'
            if (-1==e.target.className.indexOf('send-apply')) {

            } else {
              delete info.test;
            }
            auth.HcpRegister(this,info);
          } else {
            //this.$message.error("Wrong info!");
          }
        } else {
          this.$message.error("Wrong info!");
        }
      },
      nextStepA1() {

        if (false) {   // for test
          this.tabA1=false;
          this.tabA2=true;
          //
          let str_html=document.getElementById('check_email_for_code').innerHTML;
          str_html = str_html.replace('XXX@XXX.com', 'iosdevelop@medtrum.com');
          document.getElementById('check_email_for_code').innerHTML = str_html;
        } else {
          // 向服务器发送请求发送验证码，
          this.$http.post('/api/v2.1/seccode/send', {
            //user_name:'iosdevelop@medtrum.com',   // for test
            user_name:this.email,
            flag:'email',
            purpose:'update_to_hcp'
          }).then(function (res) {
            console.log("nextStepA1:", res.body);
            let err=res.body.error;
            if (0 == err) {
              this.tabA1=false;
              this.tabA2=true;
              //
              this.try_timer = setInterval(this.tryTimerHandler, 1000);
              //  替换邮件
              let str_html=document.getElementById('check_email_for_code').innerHTML;
              str_html = str_html.replace('XXX@XXX.com', 'iosdevelop@medtrum.com');
              document.getElementById('check_email_for_code').innerHTML = str_html;
            }

          }, function (err) {

          })
        }
      },
      tryAgainProc(){
        if (!this.try_enable) {
          return;
        }
        // 向服务器发送请求发送验证码，
        this.$http.post('/api/v2.1/seccode/send', {
          //user_name:'iosdevelop@medtrum.com',   // for test
          user_name:this.email,
          flag:'email',
          purpose:'update_to_hcp'
        }).then(function (res) {
          console.log("nextStepA1:", res.body);
          let err=res.body.error;
          if (0 == err) {
            this.try_enable=false;
            this.try_timer_value=60;
            //this.tabA1=false;
            //this.tabA2=true;
            //
            //this.try_timer = setInterval(this.tryTimerHandler, 1000);

          }

        }, function (err) {

        })

      },
      prevStepA1() {
        this.tabA1=false;
        this.tabA=true;
      },
      nextStepA2() {
        console.log('veri_code:', this.veri_code);
        if (!/^\d{6}$/.test(this.veri_code)) {
          let tip = this.$t('verErrTip');
          this.$message.error(tip);
          return;
        }

        let obj = document.getElementById('chooseCountry');
        let select_country = obj.value;

        this.$http.post('/api/v2.1/hcp/update_to_hcp',  {
          'veri_code':this.veri_code,
          'email':this.email,
          'country':select_country,
          'name':this.name,
          'org':this.organization,
          'phone':this.mobile,
          'flag':'change_to_hcp'
        }).then(function(res){
          let err=res.body.error;
          console.log('update_to_hcp:', res.body);
          if (0==err) {
            this.tabA2=false;
            this.tabA3=true;
          } else {
            this.veri_code='';
            let tip = this.$t('verErrTip');
            this.$message.error(tip);
            return;
          }
        }, function(err){

        })

      },
      tryTimerHandler(){
        this.try_timer_value -= 1;
        console.log("try_timer_value:", this.try_timer_value);
        if (this.try_timer_value>0) {
          this.try_timer_text = this.try_timer_value + ' ' + 'sec';
        } else if (this.try_timer_value==0) {
          this.try_timer_text='';
          this.try_enable=true;
        }
      },
      prevStepA2() {
        this.tabA1=true;
        this.tabA2=false;
      },
      checkVeriCode(){
        this.veri_focus = !this.veri_focus;
      },
      signInNow(){
        this.$router.push('/hcpLogin');
      },
      select(e){
        let country = e.target.value;
        let route ='hcpSign';
        auth.changeServer(this,country,route);
      },

      check1:function(){
        this.isA = !this.isA;
        this.isAgree= this.isA && this.isA2;
      },

      check1_2:function(){
        this.isA2 = !this.isA2;
        this.isAgree= this.isA && this.isA2;
        //console.log('isAgree:'+this.isA+','+this.isA2)
      },
      registerBack:function(){
        this.tabA=true;
        this.tabB=false;
      },
      check2:function(){
        this.isB = !this.isB;
        this.isC = !this.isC;
      },
      check3:function(){
        this.isD = !this.isD;
        this.isE = !this.isE;
      },

      check54(flag){
        this.isF = !this.isF;
        if(this.ema === ''){
          this.ema = this.$t('Enter email');
        }else{
          this.ema = '';
        }
        if(flag===1){
          if (this.$vuerify.$errors.email || this.email === '') {
            this.isO = true;
            this.disA = false;
          }else{
            this.isO = false;
            this.disA = true;
          }
        }
      },
      check57(flag){
        this.isI = !this.isI;
        if(this.nam === ''){
          this.nam = this.$t('Name');
        }else{
          this.nam = '';
        }
        if(flag===1) {
          if (this.name === '') {
            this.isR = true;
            this.disE = false;
          } else {
            this.isR = false;
            this.disE = true;
          }
        }
      },
      check58(flag){
        this.isJ = !this.isJ;
        if(this.org === ''){
          this.org = this.$t('org');
        }else{
          this.org = '';
        }
        if(flag===1) {
          if (this.organization === '') {
            this.isS = true;
            this.disF = false;
          } else {
            this.isS = false;
            this.disF = true;
          }
        }
      },
      check59(flag){
        this.isK = !this.isK;
        if(this.phone === ''){
          this.phone = this.$t('Enter mobile');
        }else{
          this.phone = '';
        }
        if(flag===1){
          if (this.$vuerify.$errors.mobile || this.mobile === '') {
            this.isT = true;
            this.disB = false;
          }else{
            this.isT = false;
            this.disB = true;
          }
        }
      },
    },
    mounted(){
      auth.initLanguages(this);
      let lang = sessionStorage.getItem('language');
      this.isDe= (lang==='de')?true:false;
      this.isIt= (lang==='it')?true:false;
      this.isPo= (lang==='po')?true:false;
      this.isSw= (lang==='sw')?true:false;
      this.isCz= (lang==='cz')?true:false;
      this.ema = this.$t('Enter email');
      this.nam = this.$t('Name');
      this.org = this.$t('org');
      this.phone =  this.$t('Enter mobile');
      let index = localStorage.getItem('index');
      if(index){
        let country = this.country[index];
        let obj = document.getElementById('chooseCountry');
        for(let i=0;i<obj.options.length;i++){
          if(obj.options[i].value===country){
            obj.options[i].selected = true;
            break;
          }
        }
      }
    },
    beforeDestroy() {
      clearInterval(this.try_timer);
    }
  }
</script>

<style scoped>
  .wrapper{
    width:400px;
    height:662px;
    margin: 0 auto;
  }
  .container{
    height:632px;
    padding-top: 30px;
    background: rgba(235,238,241,0.6);
    border-radius:14px;
  }
  .cont-head{
    height:35px;
    width:295px;
    margin:0 auto 30px;
    font-family:SFUIText-Medium;
    font-size:26px;
    color:#323232;
    letter-spacing:-0.63px;
    line-height:35px;
    text-align:center;
  }
  .DE1{
    width: 400px;
  }
  .pic{
    width:80px;
    height: 80px;
    margin:0 auto 30px;
  }
  .pic img{
    height:80px;
    width:80px;
  }

  hr{
    background:rgba(255,255,255,0.50);
    width:400px;
    height:2px;
    margin:20px 0;
    border:none;
  }
  .icon-bor,.icon-spe1,.icon-spe2{
    opacity:0.79;
    background:#ffffff;
    box-shadow:0px 2px 7px 0px rgba(210,210,210,0.50);
    font-family: SFUIText-Regular;
    border-radius:100px;
    width:320px;
    height:46px;
    margin:0 auto 17px;
  }
  .icon-bor #chooseCountry{
    width:280px;
    height:38px;
    font-family:SFUIText-Regular;
    font-size:19px;
    color:#222;
    letter-spacing:-0.49px;
    text-align:left;
    margin-left: 16px;
    margin-top: 4px;
    border:none;
    outline: none;
    padding-left: 5px;
    padding-right: 5px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url("../assets/arrow_down.png") right center no-repeat;
  }
  .icon-bor input,.icon-spe2 input{
    height:26px;
    width:260px;
    line-height: 30px;
    font-size:20px;
    font-family: SFUIText-Regular;
    letter-spacing:-0.69px;
    text-align:left;
    border: none;
    margin-top: 8px;
    margin-left:22px;
    color:#282828;
  }
  .icon-bor .DE2{
    width: 210px;
  }
  .It2 input{
    width: 210px;
  }
  .icon-bor input:focus,.icon-spe1 input:focus,.icon-spe2 input:focus{
    color: #2aace0;
    border: none;
    outline:none;
  }
  .mobile-choose{
    opacity:0.9;
    width:85px;
    height:45px;
    float: left;
    margin-left:-5px;
    border-right:1px solid #ccc;
  }
  .mobile-choose select{
    font-family:SFUIText-Regular;
    font-size:20px;
    color:#323232;
    letter-spacing:-0.66px;
    text-align:left;
    height:26px;
    margin: 11px 0 11px 20px;
    border:none;
    outline: none;
  }
  .icon-spe1 input{
    width:185px;
    font-family:SFUIText-Regular;
    font-size:20px;
    color:#d2d2d2;
    letter-spacing:-0.49px;
    text-align:left;
    display: block;
    float: left;
    margin:10px 0 11px 10px;
    border:none;
  }
  .time{
    opacity:0.8;
    background:#009fdf;
    box-shadow:0 2px 7px 0 rgba(210,210,210,0.50);
    width:80px;
    height:46px;
    float:right;
    margin-left:10px;
    border-top-right-radius: 100px;
    border-bottom-right-radius: 100px;
    cursor: pointer;
  }
  .time button{
    background: transparent;
    border:none;
    outline: none;
  }
  .time label{
    display: block;
    font-family: SFUIText-Regular;
    font-size:20px;
    width:44px;
    height:24px;
    margin-left:16px;
    color:#f6f9fa;
    margin-top:10px;
    letter-spacing:-0.49px;
    text-align:center;
    cursor: pointer;
  }
  /*为了解决输入时元素加边框带来的位置移动的问题，改变属性抵消变化*/
  .in{
    /*抵消元素的大小变化*/
    border:1px solid #009fdf;
    height:44px;
    width:318px;
  }
  .in1{
    /*抵消内部元素的位置移动*/
    margin-left:-6px;
    margin-top:-1px;
  }
  .in2{
    margin-right:-1px;
    margin-top:-1px;
  }

  /*表单验证提示框*/
  .tooltip span{
    font-family:SFUIText-Regular;
    font-size:15px;
    letter-spacing:-0.37px;
    text-align: left;
    color:#3b3b3b
  }
  .operate{
    width:290px;
    height:32px;
    margin:20px auto 22px;
  }
  .operate input{
    width:16px;
    height:32px;
    filter:alpha(opacity=0);
    opacity: 0;
    float:left;
  }
  .Select{
    background: url("../assets/Select.png") left center no-repeat;
  }
  .noSelect{
    background: url("../assets/No Select.png") left center no-repeat;
  }
  .operate label{
    font-family: SFUIText-Regular;
    font-size:14px;
    color:#5a5a5a;
    letter-spacing:-0.34px;
    text-align:left;
    display: block;
    width:262px;
    margin-left:25px;
    padding-top:7px;
  }
  .operate input{
    cursor: pointer;
  }
  .operate a{
    text-decoration: none;
    color:#009fdf;
  }
  .operate a:hover{
    opacity:0.6;
  }

  .register, .next_step{
    height: 45px;
    line-height: 45px;
    width: 324px;
    margin: 0 38px;
    font-family: SFUIText-Regular;
    box-shadow:0px 2px 7px 0px rgba(210,210,210,0.50);
    background:#009fdf;
    border-radius:100px;
    font-size:20px;
    color:#f6f9fb;
    letter-spacing:-0.49px;
    text-align:center;
    opacity:0.3;
    cursor: pointer;
    outline: none;
    border:none;
  }

  .next_step {
    opacity: 0.8;
    width:100%;
    margin:10px auto;
  }
  .next_step:hover {
    opacity: 0.9;
  }

  .send-apply {
    height: 45px;
    line-height: 45px;
    width: 200px;
    *margin: 0 20px;
    margin-top:30px;
    font-family: SFUIText-Regular;
    box-shadow:0px 2px 7px 0px rgba(210,210,210,0.50);
    background:#009fdf;
    border-radius:100px;
    font-size:20px;
    color:#f6f9fb;
    letter-spacing:-0.49px;
    text-align:center;
    opacity:0.3;
    cursor: pointer;
    outline: none;
    border:none;
  }

  .back-link {
    margin-left:40px;
  }

  .DE2{
    margin-top: 10px;
  }
  .click:hover{
    opacity:0.6;
  }
  .click{
    opacity: 0.8;
  }
  .vuerify-invalid{
    border: 1px solid #ff5252;
    height:44px;
    width:318px;
  }
  .icon-bor span,.icon-spe2 span{
    height:12px;
    line-height:12px;
    display: block;
    color: #ff5252;
    font-family: SFUIText-Regular;
    font-size: 12px;
    margin-left: 30px;
    margin-top:13px;
  }
  .icon-spe1 span{
    height:12px;
    width:140px;
    line-height:12px;
    display: block;
    color: #ff5252;
    font-family: SFUIText-Regular;
    font-size: 12px;
    margin-left:30px;
    margin-top:47px;
  }
  .policy-wrap {
    padding:20px;
  }

  .policy-wrap p{
    font-size:18px;
  }

  .policy-wrap .check input {
    opacity: 0;
  }
  .policy-wrap .check span {
    margin-left:10px;
  }
  .tabA1 p.back {
    text-align: center;
    margin-top: 20px;
    font-size:22px;
  }
  .tabA2 .title {
    text-align: center;
    *font-size: 32px;
    *font-weight: bold;
    margin-bottom:30px;
    font-family: SFUIText-Medium;
  }
  .tabA2 .icon {
    text-align: center;
    margin-bottom:30px;
  }

  .tabA2 .title p {
    font-size:24px;
  }

  .tabA2 a.try_again {
    *color:#2aace0;
    color:#979797;
    cursor: pointer;
  }

  .tabA2 a.try_again:hover {
    *color:#005dac;
  }

  .tabA2 a.try_enable {
    color:#2aace0;
  }

  .tabA2 a.try_enable:hover {
    color:#005dac;
  }

  .tabA3 .title {
    text-align: center;
    margin-bottom:30px;
    font-family: SFUIText-Medium;
  }

  .tabA3 .title p {
    font-size:24px;
  }

  .tabA3 .icon {
    text-align: center;
    margin-bottom:70px;
    margin-top:70px;
  }

  .tabA3 .text {
    text-align: center;
  }

  .tabA3 .bottom_btn {
    margin-top:100px;
  }

  .cancel{
    height: 21px;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#2aace0;
    letter-spacing:-0.44px;
    text-align:center;
    background-color: transparent;
    outline: none;
    cursor:pointer;

    height:45px;
    width:360px;
    margin:0 auto;
    border:none;
    *font-family: SFUIText-Medium;
    *outline: none;

  }

  .veri_focus{
    border:1px solid #009fdf;
    height:43px;
    width:322px;
  }

  .veri_code {
    width:360px;
    margin-top:60px;
  }

  @media screen and (max-width: 1500px){
    .wrapper{
      height:636px;
    }
    .container{
      height:606px;
    }
    .cont-head{
      margin:0 auto 20px;
    }
    .pic{
      margin:0 auto 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// hcpSign.vue?c1daf9d0